import React from 'react';
import { Package, HelpCircle, LogOut, Menu, X } from 'lucide-react';

interface HeaderProps {
  sidebarOpen: boolean;
  setSidebarOpen: (open: boolean) => void;
  userEmail: string;
  onLogout: () => void;
}

const Header: React.FC<HeaderProps> = ({ sidebarOpen, setSidebarOpen, userEmail, onLogout }) => {
  const username = userEmail.split('@')[0];
  const initial = username.charAt(0).toUpperCase();

  return (
    <header className="bg-gray-800 border-b border-gray-700 sticky top-0 z-50 shadow-sm">
      <div className="px-6 py-4 flex items-center justify-between">
        <div className="flex items-center gap-4">
          <button onClick={() => setSidebarOpen(!sidebarOpen)} className="lg:hidden p-2 hover:bg-gray-700 rounded-lg text-white">
            {sidebarOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 bg-gradient-to-br from-teal-600 to-blue-700 rounded-lg flex items-center justify-center">
              <Package className="text-white" size={24} />
            </div>
            <div>
              <h1 className="text-2xl font-bold gradient-text font-mono">BORDERLOGIX</h1>
              <p className="text-xs text-gray-400 font-mono">CORE SYSTEM v2.0</p>
            </div>
          </div>
        </div>
        <div className="flex items-center gap-4">
          <button className="p-2 hover:bg-gray-700 rounded-lg transition-colors">
            <HelpCircle size={20} className="text-gray-400" />
          </button>
          <div className="flex items-center gap-3 px-4 py-2 bg-gray-700 rounded-lg">
            <div className="w-8 h-8 bg-gradient-to-br from-teal-500 to-blue-600 rounded-full flex items-center justify-center text-white font-semibold text-sm">
              {initial}
            </div>
            <div className="hidden md:block">
              <p className="text-sm font-semibold text-gray-200">{username}</p>
              <p className="text-xs text-gray-400 truncate max-w-[150px]">{userEmail}</p>
            </div>
          </div>
          <button 
            onClick={onLogout}
            className="p-2 hover:bg-red-900/50 text-red-500 rounded-lg transition-colors"
            title="Logout"
          >
            <LogOut size={20} />
          </button>
        </div>
      </div>
    </header>
  );
};

export default Header;